import "./SignupPage.css";

const SignupPage = () => {
  return <></>;
};

export { SignupPage };
